// @ts-nocheck
import _ from 'lodash';

class StringUtils {
  static makeId(id, suffix) {
    if (_.isEmpty(id)) {
      return undefined;
    }
    if (_.isEmpty(suffix)) {
      return id;
    }
    return id.concat(`-${suffix}`);
  }

  static getFormattedSum(sum) {
    const parsedSum = _.toNumber(sum);
    if (_.isNaN(parsedSum)) {
      return '0,00 Kr.';
    }
    return `${(parsedSum / 100).toFixed(2).replace('.', ',')} Kr.`;
  }

  static getFormattedDecimal(sum) {
    const parsedSum = _.toNumber(sum);
    if (_.isNaN(parsedSum)) {
      return '0,00';
    }
    return (parsedSum / 100).toFixed(2).replace('.', ',');
  }

  static getFormattedDiscount(discount, discountType) {
    return discountType === 'PERCENT' ? `${discount} %` : this.getFormattedSum(discount);
  }

  static getFormattedDays(days) {
    if (!_.isNumber(days) && _.isEmpty(days)) {
      return '';
    }
    return `${days} dage`;
  }

  static getFormattedHours(days) {
    if (!_.isNumber(days) && _.isEmpty(days)) {
      return '';
    }
    return `${days} timer`;
  }

  static getFormattedMinutes(days) {
    if (!_.isNumber(days) && _.isEmpty(days)) {
      return '';
    }
    return `${days} minutter`;
  }

  static compare(s1, s2, numeric = false) {
    return _.defaultTo(s1, '').localeCompare(s2, undefined, { numeric });
  }

  static getEnumTranslation(t, basePath, enumToBeTranslated, defaultValue) {
    return this.getTranslation(t, basePath, enumToBeTranslated?.toLowerCase(), defaultValue);
  }

  static getTranslation(t, basePath, valueToBeTranslated, defaultValue) {
    return (
      (valueToBeTranslated
        ? this.getTranslationByKey(t, `${basePath}.${valueToBeTranslated}`) ?? defaultValue
        : defaultValue) ?? t('common.unknown')
    );
  }

  static getTranslationByKey(t, prop) {
    const translation = t(prop);
    return translation !== prop ? translation : null;
  }
}

export default StringUtils;
